import { gql } from '@apollo/client';
export const FETCH_FILE_URL = gql(`
  query file_download_file($id: Int!) {
    file_download_file(id: $id) {
      resource_url
      id
    }
  }
`);
export const UPLOAD_FILE = gql `
  mutation uploadFile($file_type_id: Int!, $original_name: String!, $owner_id: Int!, $extension: String!) {
    file_upload_file(
      file_type_id: $file_type_id
      original_name: $original_name
      owner_id: $owner_id
      extension: $extension
    ) {
      id
      data
      expires_in
      key
    }
  }
`;
export const HEART_BEAT = gql(`
  query heartBeat($test_instance_id: Int!, $seconds_elapsed: Int) {
    canx_heart_beat(test_instance_id: $test_instance_id, seconds_elapsed: $seconds_elapsed) {
      test_instance_id
    }
  }
`);
export const GET_STEP_DETAILS = gql(`
  query canx_get_step_details($step_id: Int!) {
    canx_get_step_details(step_id: $step_id) {
      id
      name
      flow_id
      flow_details {
        project {
          id
          token
        }
        flow_configs {
          ep_policy {
            mode
            policy_rules {
              action
              software {
                name
              }
              content_protection
              clear_clipboard
              kiosk_mode
            }
          }
          status
        }
      }
      is_proctoring
      proview_type
      step_forms {
        id
        step_form_type
        form {
          id
          type
        }
      }
      step_windows {
        duration
        starts_at
        step_id
        window_type
        ends_at
      }
      workflow {
        id
        external_id
      }
      workflow_candidate_steps {
        id
        step_id
        status {
          name
          id
        }
        accommodations {
          type
          status
          duration_percentage
        }
        test_instances {
          id
        }
      }
      intro {
        doc {
          content
          id
          props
          children {
            content
            id
            props
            type
          }
          type
        }
      }
      outro {
        doc {
          content
          id
          props
          children {
            content
            id
            props
            type
          }
          type
        }
      }
      next_step {
        step_id
        step_type
      }
    }
  }
`);
// Separate from GET_STEP_DETAILS so step details keep working before CX-6077 (supergraph#15740) is deployed:
// only self-book invites (cx_self_schedule_enabled + wcs_id) send it, so keep the flag off until the BE ships.
export const GET_STEP_DRIVE_OCCURRENCES = gql(`
  query canx_get_step_drive_occurrences($step_id: Int!) {
    canx_get_step_details(step_id: $step_id) {
      id
      drive_occurrences {
        id
        drive_schedule_id
        start_date
        end_date
        status
        drive_occurrence_guests {
          from
          to
          status
        }
      }
    }
  }
`);
